import React, { useEffect, useState, useContext, useRef } from 'react'
import "./AdvanceSearchTalentCommunity.css"
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import OutlinedInput from '@mui/material/OutlinedInput';
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import Skeleton from '@mui/material/Skeleton';
import DataTable from '../../../components/DataTable/DataTable';
import candidateCombinedSearch from '../../../apis/candidateCombinedSearch';
import candidateSearch from '../../../apis/candidateSearch';
import getAllIndustries from '../../../apis/getAllIndustries';
import getAllCompanies from '../../../apis/getAllCompanies';
import candidateKeySearch from '../../../apis/candidateKeySearch';
import { NotificationManager } from "react-notifications";
import getAllDegrees from '../../../apis/getAllDegrees';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import getAllCandidateProfileByOrgId from '../../../apis/getAllCandidateProfileByOrgId/getAllCandidateProfileByOrgId';
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "../../../components/Icons/editicon";

import { CandidateCard } from './CandidateDrawerCard';
import getTalentCommunityStatics from '../../../apis/myTallentCommunityByOrgId/myTalentCommunityStaticsByOrgId';


import EditActivity from '../../../components/EditActivity/EditActivity';
import { UserTypeContext } from '../../../AppRoute';

import CloseIcon from '@mui/icons-material/Close';
import BulkSubmitModal from '../bulkSubmitDialog/BulkSubmitModal';
import Checkbox from '@mui/material/Checkbox';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import fetchCountryStateCity from '../../../apis/fetchCountryStateCity';
import Person from "../../../components/Icons/person"
import Calander from "../../../components/Icons/calander"
import AddLastWeek from "../../../components/Icons/addlastweek"
import ExcelIcon from '../../../components/Icons/excelicon';
import SelectList from '../../../components/Icons/selectlist';
import UnauthorizedAccess from '../../../components/UnauthorizedAccess/UnauthorizedAccess';


const tab_types = {
    search_candidates: 'Search Candidates',
    recommended_candidates: 'Recommended Candidates'
};


const styleSx = {
    odd: {
        background: '#F6F6F6 !important'
    },
    even: {

        background: '#fffff !important'
    },
    profileButton: {
        color: '#fff',
        backgroundColor: '#1885e6',
        width: '70px',
        '&:hover': {
            backgroundColor: '#1885e6',
            opacity: '0.9'
        }
    },
    activityButton: {
        color: '#fff',
        backgroundColor: '#1885e6',
        width: '70px',
        marginLeft: '15px',
        '&:hover': {
            backgroundColor: '#1885e6',
            opacity: '0.9'
        }
    },
    globalSearchButton: {
        color: '#fff',
        backgroundColor: '#1885e6',
        marginRight: '-8px',
        borderRadius: '6px',
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
        '&:hover': {
            backgroundColor: '#1885e6',
            opacity: '0.9'
        }
    },
    backdrop: {
        zIndex: 1201,
        color: '#fff',
    },
    waitingText: {
        marginLeft: '5px'
    },
    openTab: {
        backgroundColor: "#1885e6",
        color: "#FFFFFF",
    },
    search: {
        position: 'relative',
        backgroundColor: "#d1e8ff",
        marginLeft: 0,
        width: '70%',
        marginTop: '4px',
        borderRadius: "5px",
        height: "25px"
    },
    buttonForSupport: {
        justifyContent: "flex-end !important",
        padding: "7px 39px 18px !important",
    },
    autocomplete: {

    },
    searchIcon: {
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        //   color: 'inherit',

    },
    inputInput: {
        padding: "0px 32px",
        // vertical padding + font size from searchIcon
        paddingLeft: "0px",
        transition: 'width 300ms ease',
        width: '100%',
        //   backgroundColor:"#d1e8ff",
        '@media (min-width: 960px)': {
            width: '160px',
        },

    },

    title: {
        backgroundImage: "linear-gradient(90deg, rgba(49, 179, 248, 1) 0%, rgba(29, 105, 146, 1) 100%);!important"
    }

}

const AdvanceSearchTalentCommunity = (props) => {
    const location = useLocation();
    const { userType, userRecords } = useContext(UserTypeContext);
    const id = userType === 'Admin' ? location?.state?.id : userRecords?.id;
    const userRecruitmentpartnerId = userType === 'Admin' ? location?.state?.recruitmentPartnerId : userRecords?.recruitmentpartnerId;
    const userRole = location?.state?.userRole ? location?.state?.userRole : userRecords?.role?.roleName;
    const userRecrodData = userType === 'Admin' ? location?.state?.userRecords : userRecords;
    const [recId, setRecId] = useState("")
    const { requisitionId } = useParams()
    const [reqId, setReqId] = useState(requisitionId)
    const [scorePercentage, setScorePercentage] = useState(0)
    const [allCandidateSearchResponse, setAllCandidateSearchResponse] = useState([])
    const [dataResult, setDataResult] = useState([])
    const [dataResult1, setDataResult1] = useState([])
    const [degrees, setDegrees] = useState([])
    const [allCompanies, setAllCompanies] = useState([])
    const [companyNotListed, setCompanyNotListed] = useState(false)
    const [currentSalaryValue, setCurrentSalaryValue] = useState("")
    const [expectedSalaryValue, setExpectedSalaryValue] = useState("")
    const [booleanFilterOn, setBooleanFilterOn] = useState(true)
    const [isSearching, setIsSearching] = useState(true)
    const [isSearching_recommended, setIsSearching_recommended] = useState(true)
    const [recruitmentpartnerId, setRecruimentPartnerId] = useState("")
    const [communityStats, setCommunityStats] = React.useState([]);
    const [communityStatsLoader, setCommunityStatsLoader] = React.useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState("")
    const [selectedIndustry, setSelectedIndustry] = useState("")
    const [selectedCompany, setSelectedCompany] = useState("")
    const [selectedEducation, setSelectedEducation] = useState([])
    const [noticeperiod, setNoticeperiod] = useState("")
    const [selectedUnlistedCompany, setSelectedUnlistedCompany] = useState("")
    const [minExperience, setMinExperience] = useState("")
    const [maxExperience, setMaxExperience] = useState("")
    const [keywordOptions, setKeywordOptions] = useState([])
    const [keywordCurrentValue, setKeywordCurrentValue] = useState("")
    const [selectedKeywords, setSelectedKeywords] = useState([])
    const [allIndustries_candidateSearch, setAllIndustries_candidateSearch] = useState([])

    const [serachingThroughTestScore, setSerachingThroughTestScore] = useState(false)

    const [primarySkillOptions, setPrimarySkillOptions] = useState([])
    const [primarySkillValues, setPrimarySkillValues] = useState([])
    const [currentPrimarySkillValue, setCurrentPrimarySkillValue] = useState("");

    const [additionalSkillOptions, setAdditionalSkillOptions] = useState([])
    const [additionalSkillValues, setAdditionalSkillValues] = useState([])
    const [currentAdditionalSkillValue, setCurrentAdditionalSkillValue] = useState("");

    const [totalCandidateCount, setTotalCandidateCount] = useState(0)
    const [totalCandidateCount_RecommendedCandidates, setTotalCandidateCount_RecommendedCandidates] = useState(0)

    const [candidateSearchPayload, setCandidateSearchPayload] = useState({})
    const [typeOfSearch, setTypeOfSearch] = useState("")
    const [isCandidateSearch, setIsCandidateSearch] = useState(false)
    const [tableFilterArray, setTableFilterArray] = useState([])
    const [dataTableResetKey, setDataTableResetKey] = useState(0);
    const [selectedCandidates, setSelectedCandidates] = useState([]);


    const [takeNumberOfResult, setTakeNumberOfResult] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);

    const [sortingField, setSortingField] = useState("created_at");
    const [sortingOrder, setSortingOrder] = useState("desc");
    const [isExporting, setIsExporting] = useState(false);
    const [email] = useState("")
    const [tabSwitchCount, setTabSwitchCount] = useState(0);
    const [edit, setEdit] = useState(false)
    const [isActivity, setisActivity] = useState(false);
    const [allRequisitionData, setAllRequisitionData] = useState([]);

    const currencyCodes = ["USD", "EUR", "GBP", "JPY", "CAD", "AUD", "CHF", "CNY", "INR", "ZAR"];
    const [row_DataItem] = useState("")
    const hasInitialAPiRun = useRef(false);

    const [filterLoader, setFilterLoader] = useState({
        industry: false,
        company: false,
        degree: false,
    })

    // Column definitions for DataTable
    const getColumnsForRecommendedCandidates = () => [
        {
            header: 'Action',
            accessorKey: 'action',
            enableColumnFilter: false,
            enableSorting: false,
            size: 150,
            cell: ({ row }) => {
                const dataItem = row.original;
                const isChecked = selectedCandidates.some(item => item.candidateId === dataItem.candidateId);

                return (
                    <div className='action-cell'>
                        <Checkbox
                            checked={isChecked}
                            onChange={() => handleCheckboxChange({ dataItem })}
                            disabled={!isChecked && selectedCandidates.length >= 5}
                            size="small"
                        />
                        <Button
                            size="small"
                            variant="contained"
                            sx={styleSx.profileButton}
                            onClick={() => handleGotoProfile({ dataItem })}
                            className='profile-button'
                        >
                            Profile
                        </Button>
                    </div>
                );
            }
        },
        {
            header: 'Candidate Name',
            accessorKey: 'name',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'Email',
            accessorKey: 'emailID',
            enableColumnFilter: false,
            enableSorting: true,
            size: 250,
        },
        {
            header: 'Primary Skill',
            accessorKey: 'primarySkill',
            enableColumnFilter: false,
            enableSorting: true,
            size: 200,
        },
        {
            header: 'Additional Skills',
            accessorKey: 'allSkill',
            enableColumnFilter: false,
            enableSorting: false,
            size: 600,
            cell: ({ row }) => {
                const dataItem = row.original;
                const skillDataString = dataItem && dataItem?.allSkill;
                return (
                    <div>
                        {skillDataString}
                        {skillDataString && skillDataString.length === 100 ? (
                            <span onClick={() => handleMoreClick({ dataItem })} className='expandtext_kendo'>
                                ...show more
                            </span>
                        ) : skillDataString && skillDataString.length > 100 ? (
                            <span onClick={() => handlelessClick({ dataItem })} className='expandtext_kendo'>
                                ...show less
                            </span>
                        ) : ''}
                    </div>
                );
            }
        },
        // {
        //     header: 'Employment',
        //     accessorKey: 'employment',
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 170,
        // },
        // {
        //     header: 'Company Name',
        //     accessorKey: 'companyName',
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 170,
        // },
        {
            header: 'Country',
            accessorKey: 'country',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'State',
            accessorKey: 'state',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'City',
            accessorKey: 'city',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'Educational Degree',
            accessorKey: 'degreeField',
            enableColumnFilter: false,
            enableSorting: false,
            size: 400,
        },
        {
            header: 'Years of Experience',
            accessorKey: 'yr_of_exp',
            enableColumnFilter: false,
            enableSorting: true,
            size: 170,
            cell: ({ row }) => {
                const dataItem = row.original;
                if (!dataItem.yr_of_exp) {
                    return 'N/A';
                }
                return dataItem.yearsofexp;
            }
        }
    ];

    const getColumnsForSearchCandidates = () => [
        {
            header: 'Action',
            accessorKey: 'action',
            enableColumnFilter: false,
            enableSorting: false,
            size: 180,
            cell: ({ row }) => {
                const dataItem = row.original;
                const isChecked = selectedCandidates.some(item => item.candidateId === dataItem.candidateId);

                return (
                    <div className='action-cell'>
                        <Checkbox
                            checked={isChecked}
                            onChange={() => handleCheckboxChange({ dataItem })}
                            disabled={!isChecked && selectedCandidates.length >= 5}
                            size="small"
                        />
                        <Button
                            size="small"
                            variant="contained"
                            sx={styleSx.profileButton}
                            onClick={() => handleGotoProfile({ dataItem })}
                            className='profile-button'
                        >
                            Profile
                        </Button>
                    </div>
                );
            }
        },
        {
            header: 'Candidate Name',
            accessorKey: 'name',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'Email',
            accessorKey: 'emailID',
            enableColumnFilter: false,
            enableSorting: true,
            size: 250,
        },
        {
            header: 'Primary Skill',
            accessorKey: 'primarySkill',
            enableColumnFilter: false,
            enableSorting: true,
            size: 200,
        },
        {
            header: 'Additional Skills',
            accessorKey: 'allSkill',
            enableColumnFilter: false,
            enableSorting: false,
            size: 600,
            cell: ({ row }) => {
                const dataItem = row.original;
                const skillDataString = dataItem.allSkill;
                return (
                    <div>
                        {skillDataString}
                        {skillDataString && skillDataString.length === 100 ? (
                            <span onClick={() => handleMoreClick({ dataItem })} className='expandtext_kendo'>
                                ...show more
                            </span>
                        ) : skillDataString && skillDataString.length > 100 ? (
                            <span onClick={() => handlelessClick({ dataItem })} className='expandtext_kendo'>
                                ...show less
                            </span>
                        ) : ''}
                    </div>
                );
            }
        },
        // {
        //     header: 'Employment',
        //     accessorKey: 'employment',
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 170,
        // },
        // {
        //     header: 'Company Name',
        //     accessorKey: 'companyName',
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 170,
        // },
        {
            header: 'Country',
            accessorKey: 'country',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'State',
            accessorKey: 'state',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'City',
            accessorKey: 'city',
            enableColumnFilter: false,
            enableSorting: true,
            size: 150,
        },
        {
            header: 'Phone Number',
            accessorKey: 'phoneNumber',
            enableColumnFilter: false,
            enableSorting: true,
            size: 400,
        },
        {
            header: 'Educational Degree',
            accessorKey: 'degreeField',
            enableColumnFilter: false,
            enableSorting: false,
            size: 400,
        },
        {
            header: 'Years of Experience',
            accessorKey: 'yr_of_exp',
            enableColumnFilter: false,
            enableSorting: true,
            size: 170,
            cell: ({ row }) => {
                const dataItem = row.original;
                if (!dataItem.yr_of_exp) {
                    return 'N/A';
                }
                return dataItem.yearsofexp;
            }
        },
        ...(serachingThroughTestScore ? [
            {
                header: 'Test Name',
                accessorKey: 'testnames',
                enableColumnFilter: false,
                enableSorting: false,
                size: 250,
            },
            {
                header: 'Test Skills',
                accessorKey: 'testskills',
                enableColumnFilter: false,
                enableSorting: false,
                size: 250,
            },
            {
                header: 'Test Scores',
                accessorKey: 'testScores',
                enableColumnFilter: false,
                enableSorting: true,
                size: 170,
            }
        ] : [])
    ];

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [openBukSubmitModal, setOpenBukSubmitModal] = useState(false);
    const [locationList, setLocationList] = useState({
        countryList: [],
        stateList: [],
        cityList: [],
        isCountryFetching: false,
        isStateFetching: false,
        isCityFetching: false,
    });

    const [userInformation, setUserInformation] = useState({
        locationCountry: {},
        locationState: {},
        locationCity: {},
    })


    // Helper function to process table filters into additionalFilterArr format
    const processTableFilters = (tableFilterArray) => {
        let additionalFilterArr = {}
        
        for (let element of tableFilterArray) {
            if (element.field === "emailID") {
                additionalFilterArr.email = element.value.trim()
            }
            else if (element.field === "name") {
                additionalFilterArr.candidateName = element.value.trim()
            }
            else if (element.field === "primarySkill") {
                additionalFilterArr.primarySkill = [element.value.trim()]
            }
            else if (element.field === "degreeField") {
                let degreeArr = [];
                let degreeFieldArr = element.value.split(",")
                degreeFieldArr.forEach(element => {
                    degreeArr.push(element.trim())
                });
                additionalFilterArr.education = degreeArr;
            }
            else if (element.field === "yr_of_exp") {
                let yoeVal = element.value
                additionalFilterArr.yearsofexp = yoeVal
            }
            else if (element.field === "country") {
                additionalFilterArr.country = element.value.trim()
            }
            else if (element.field === "state") {
                additionalFilterArr.state = element.value.trim()
            }
            else if (element.field === "city") {
                additionalFilterArr.city = element.value.trim()
            }
            else if (element.field === "testnames") {
                let testnamesArr = element.value.split(",")
                let testnames = [];
                testnamesArr.forEach(element => {
                    testnames.push(element.trim())
                });
                additionalFilterArr.testnames = testnames;
            }
            else if (element.field === "testskills") {
                let testskillsArr = element.value.split(",")
                let testskills = [];
                testskillsArr.forEach(element => {
                    testskills.push(element.trim())
                });
                additionalFilterArr.testskills = testskills;
            } else if (element.field === "phoneNumber") {
                additionalFilterArr.phoneNumber = element.value.trim()
            }
        }
        
        return additionalFilterArr;
    };

    // Helper function to create search payload with filters, sorting, and pagination
    const createFilteredSearchPayload = (page, size, sortingField, sortingOrder) => {
        if (tableFilterArray.length > 0) {
            const additionalFilterArr = processTableFilters(tableFilterArray);
            const searchDecisionArr = getSearchDecisionAndPayload(additionalFilterArr);
            
            return {
                searchDecision: searchDecisionArr.searchDecision,
                searchPayloadData: { 
                    ...searchDecisionArr.payload, 
                    page: page,
                    size: size,
                    sortingField: sortingField,
                    sortingOrder: sortingOrder,
                    userId: id
                }
            };
        } else {
            return {
                searchDecision: typeOfSearch,
                searchPayloadData: { 
                    ...candidateSearchPayload,
                    page: page,
                    size: size,
                    sortingField: sortingField,
                    sortingOrder: sortingOrder
                }
            };
        }
    };

    // Handle server-side filtering for DataTable
    const handleServerSideFilter = (filters) => {
        // Convert TanStack filters to the format expected by the backend
        const validFilters = filters.filter(filter => {
            const value = filter.value;
            return value !== null && value !== undefined && value.toString().trim() !== '';
        });
        const backendFilters = validFilters.map(filter => ({
            field: filter.id,
            value: filter.value,
            operator: 'contains'
        }));
        // Create a Kendo-compatible filter structure for the existing logic
        const kendoCompatibleFilters = backendFilters.map(filter => ({
            field: filter.field,
            value: filter.value,
            operator: filter.operator
        }));
        // Always update the filter array
        setTableFilterArray(kendoCompatibleFilters);
        // When filters are applied, reset pagination to page 1
        if (kendoCompatibleFilters.length > 0) {
            setPageNumber(1);
            setTakeNumberOfResult(20);
        }
        // If no valid filters and we were handling filtered search, reset
        if (kendoCompatibleFilters.length === 0 && tableFilterArray.length > 0) {
            // Reset pagination to first page
            const resetDataState1 = {
                skip: 0,
                take: 20,
                filter: { logic: "and", filters: [] }
            };
            setDataState1(resetDataState1);
            setPageNumber(1);
            setTakeNumberOfResult(20);
            // Reset to original data
            if (isCandidateSearch) {
                // If we had candidate search results, go back to those
                const resetPayload = {
                    ...candidateSearchPayload,
                    page: 1,
                    size: 20,
                    sortingField: sortingField || "created_at",
                    sortingOrder: sortingOrder || "desc"
                };
                handleCandidateSearchStateChange(typeOfSearch, resetPayload, 1, 20);
            } else {
                // Reset to organization candidate list
                handleCandidateSearchByOrgId(1, 20, {
                    sortingField: "created_at",
                    sortingOrder: "desc"
                });
            }
        }
    };

    const handleDrawerOpen = () => setDrawerOpen(true);
    const handleDrawerClose = () => setDrawerOpen(false);

    const handleRemoveCandidate = (candidateId) => {
        setSelectedCandidates(prev => prev.filter(item => item.candidateId !== candidateId));
    };


    const handleBulkSubmit = () => {
        handleDrawerClose();
        setOpenBukSubmitModal(true);
    };





    const dataForNoticePeriod = [
        { value: 30, label: "30 days" },
        { value: 45, label: "45 days" },
        { value: 60, label: "60 days" },
        { value: 90, label: "90 days" }
    ];

    const [dataState, setDataState] = useState({
        skip: 0,
        take: 20,
        filter: {
            logic: "and",
            filters: [],
        },
    });

    const [dataState1, setDataState1] = useState({
        skip: 0,
        take: 20,
        filter: {
            logic: "and",
            filters: [],
        },
    });

    const initialDataState = {
        skip: 0,
        take: 20,
        filter: {
            logic: "and",
            filters: [],
        },
    };

    const [openedTab, setOpenedTab] = useState();


    const history = useNavigate();

    const handleCandidateSearchByOrgId = async (page, size, searchPayloadData) => {
        let _recruitmentpartnerId = userRecruitmentpartnerId
        setDataResult1([])
        setIsSearching(true)
        try {
            let payload = {
                page: page,
                size: size,
                sortingField: searchPayloadData.sortingField,
                sortingOrder: searchPayloadData.sortingOrder,
            }
            let allCandidateResponse = await getAllCandidateProfileResponse(_recruitmentpartnerId, payload, isExporting, openedTab)
            setAllCandidateSearchResponse(allCandidateResponse)
            setDataResult1(allCandidateResponse);
        } catch (error) {
            console.log("error", error)
        } finally {
            setIsSearching(false)
        }
    }


    // Get Community Stats Data
    const getCommunityStaticsData = async () => {
        try {
            let _recruitmentpartnerId = userRecruitmentpartnerId ? userRecruitmentpartnerId : "";

            if (_recruitmentpartnerId) {
                let res = await getTalentCommunityStatics(_recruitmentpartnerId);
                setCommunityStats(res?.data);
                setCommunityStatsLoader(true)
            }
        } catch (error) {
            console.log("error", error);
        } finally {
        }
    }


    const getAllCandidateProfileResponse = async (orgId, payload, exportExcel, tab) => {
        let arr = [];
        payload.isRequistion = false;
        payload.requisitionIdVal = ""
        if (requisitionId && tab === 'Recommended Candidates') {
            payload.isRequistion = true;
            payload.requisitionIdVal = requisitionId;
            payload.totalData = 10;
        }
        payload.userRecruitmentpartnerId = userRecruitmentpartnerId;
        payload.userId = id;
        let responseData;
        if (orgId) {
            responseData = await getAllCandidateProfileByOrgId(orgId, payload);
        }
        let response = responseData[0]?.data
        if (!exportExcel) {
            if (responseData[0]?.totalCount[0]?.total) {
                if (requisitionId && tab === 'Recommended Candidates') {
                    setTotalCandidateCount_RecommendedCandidates(responseData[0].totalCount[0].total)
                }
                else {
                    setTotalCandidateCount(responseData[0].totalCount[0].total)
                }
            }
            else {
                setTotalCandidateCount(0)
            }
        }
        for (let i = 0; i < response.length; i++) {
            let yoe = response[i].yr_of_exp ? parseInt(response[i].yr_of_exp) : 0
            let fulladdress = " " + (response[i].address ? response[i].address + ", " : '') + (response[i].city ? response[i].city + ", " : '') + (response[i].state ? response[i].state + ", " : '') + (response[i].country ? response[i].country + " " : '')
            let allSkillString = handleSkillMerge(response[i].skills)
            let allAdditionalSkillString = response[i].skills.join(", ")
            if (allSkillString.length > 100) {
                allSkillString = allSkillString.substring(0, 100)
            }
            let degreesValue = response[i].degrees
            let degreeStr = '';
            for (let j = 0; j < degreesValue.length; j++) {
                if (j === degreesValue.length - 1) {
                    degreeStr = degreeStr + degreesValue[j].trim()
                }
                else {
                    degreeStr = degreeStr + degreesValue[j].trim() + ', '
                }
            }
            let testnames = ""
            let testskills = ""
            let testScores = ""
            if (response[i]?.testDetails && response[i]?.testDetails.length > 0) {
                let testDetails = response[i].testDetails;
                for (let j = 0; j < testDetails.length; j++) {
                    if (j === testDetails.length - 1) {
                        testnames += testDetails[j].testName
                        testskills += testDetails[j].testSkillName
                        testScores += testDetails[j].testScore + "%"
                    }
                    else {
                        testnames += testDetails[j].testName + ", "
                        testskills += testDetails[j].testSkillName + ", "
                        testScores += testDetails[j].testScore + "% , "
                    }
                }
            }
            arr.push(
                Object.assign(
                    response[i],
                    { allSkill: allSkillString },
                    { allAdditionalSkill: allAdditionalSkillString },
                    { fulladdress: fulladdress },
                    { yearsofexp: yoe },
                    { degreeField: degreeStr },
                    { testnames: testnames },
                    { testskills: testskills },
                    { testScores: testScores }
                )
            );
        }
        return arr;
    }



    const percentageScoreHandler = (e, value) => {
        setScorePercentage(value)
    }

    const handleCheckboxChange = (props) => {
        const dataItem = props.dataItem;
        setSelectedCandidates(prev => {
            const alreadySelected = prev.find(item => item.candidateId === dataItem.candidateId);
            if (alreadySelected) {
                return prev.filter(item => item.candidateId !== dataItem.candidateId);
            } else {
                if (prev.length < 5) {
                    return [...prev, dataItem];
                } else {
                    alert("You can select up to 5 candidates only.");
                    return prev;
                }
            }
        });
    };




    const handleGotoProfile = async (props) => {
        if (props.dataItem.powerResumeId) {
            window.open(`/candidate/profile/${props.dataItem.powerResumeId}/${recruitmentpartnerId}`, "_blank")
        }
        else {
            window.open(`/only-candidate-profile/${props.dataItem.candidateId}`, "_blank")
        }
    }

    const companyChangeHandler = (e, value) => {
        if (value) {
            if (value.name === "others") {
                setCompanyNotListed(true)
                setSelectedCompany(value)
            }
            else {
                setSelectedCompany(value)
                setCompanyNotListed(false)
                setSelectedUnlistedCompany('')
            }
        }
        else {
            setSelectedCompany("")
            setCompanyNotListed(false)
            setSelectedUnlistedCompany('')
        }
    }

    const expectedSalaryHandler = (e) => {
        setExpectedSalaryValue(e.target.value)
    }

    const currentSalaryHandler = (e) => {
        setCurrentSalaryValue(e.target.value)
    }

    const fetchLocationInformation = async (field) => {
        if (field === "country") {
            setLocationList((prev) => ({
                ...prev,
                isCountryFetching: true,
            }));
            try {
                let payload = {
                    actionName: "country"
                }

                let response = await fetchCountryStateCity(payload)
                if (response.status === 200) {
                    setLocationList({
                        ...locationList,
                        isCountryFetching: false,
                        countryList: response.data.data
                    })
                }
            } catch (error) {
                NotificationManager.error(
                    "Unable to load country list. Please try again later.",
                    "Error",
                    10000
                )
                setLocationList((prev) => ({
                    ...prev,
                    isCountryFetching: false,
                    countryList: [],
                }));
            }
        }
        else if (field === "state") {
            setLocationList((prev) => ({
                ...prev,
                isStateFetching: true,
            }));
            try {

                let payload = {
                    actionName: "state",
                    countryCode: userInformation.locationCountry.isoCode
                }

                let response = await fetchCountryStateCity(payload)
                if (response.status === 200) {
                    setLocationList({
                        ...locationList,
                        isStateFetching: false,
                        stateList: response.data.data
                    })
                }

            } catch (error) {
                NotificationManager.error(
                    "Unable to load state list. Please try again later.",
                    "Error",
                    10000
                )
                setLocationList((prev) => ({
                    ...prev,
                    isStateFetching: false,
                    stateList: [],
                }));

            }
        }
        else if (field === "city") {
            setLocationList((prev) => ({
                ...prev,
                isCityFetching: true,
            }));
            try {
                let payload = {
                    actionName: "city",
                    stateCode: userInformation.locationState.isoCode,
                }

                let response = await fetchCountryStateCity(payload)
                if (response.status === 200) {
                    setLocationList({
                        ...locationList,
                        isCityFetching: false,
                        cityList: response.data.data
                    })
                }
            } catch (error) {
                NotificationManager.error(
                    "Unable to load city list. Please try again later.",
                    "Error",
                    10000
                )
                setLocationList((prev) => ({
                    ...prev,
                    isCityFetching: false,
                    cityList: [],
                }));
            }
        }
    }

    const countryHandler_candidateSearch = (event, value) => {
        if (value) {
            setUserInformation({
                ...userInformation,
                locationCountry: value,
                locationState: {},
                locationCity: {},
            });
            setLocationList((prev) => ({
                ...prev,
                stateList: [],
                cityList: [],
            }));
        }
        else {
            setUserInformation({
                ...userInformation,
                locationCountry: {},
                locationState: {},
                locationCity: {},
            })
            setLocationList((prev) => ({
                ...prev,
                stateList: [],
                cityList: [],
            }));
        }
    };
    const stateHandler_candidateSearch = (event, value) => {
        if (value) {
            setUserInformation({
                ...userInformation,
                locationState: value,
                locationCity: {},
            })
            setLocationList((prev) => ({
                ...prev,
                cityList: []
            }));
        }
        else {
            setUserInformation({
                ...userInformation,
                locationState: {},
                locationCity: {},
            })
            setLocationList((prev) => ({
                ...prev,
                cityList: []
            }));
        }
    };


    const cityHandler_candidateSearch = (event, value) => {
        setUserInformation({
            ...userInformation,
            locationCity: value
        })
    };

    const currencyChangeHandler = (e, value) => {
        if (value)
            setSelectedCurrency(value)
        else setSelectedCurrency("")
    }
    const industryChangeHandler = (e, value) => {
        if (value)
            setSelectedIndustry(value)
        else setSelectedIndustry("")
    }

    const unlistedCompanyValuechangeHandler = (e) => {
        if (e.target.value) {
            setSelectedUnlistedCompany(e.target.value)
        }
        else setSelectedUnlistedCompany("")
    }

    const educationHandler = (e, value) => {
        if (value) {
            setSelectedEducation(value)
        }
        else {
            selectedEducation([])
        }
    }

    const noticeperiodHandler = (e, value) => {
        if (value) {
            setNoticeperiod(value)
        }
        else {
            setNoticeperiod("")
        }
    }

    const minExperienceHandler = (e) => {
        setMinExperience(e.target.value)
        if (!maxExperience || e.target.value > maxExperience)
            setMaxExperience(e.target.value)
    }
    const maxExperienceHandler = (e) => {
        setMaxExperience(e.target.value)
    }

    const getEducationData = (eduData) => {
        let arr = []
        for (let i = 0; i < eduData.length; i++) {
            arr.push(eduData[i].degreename)
            let alternativeValues = eduData[i].alternative
            if (alternativeValues.length > 0) {
                for (let j = 0; j < alternativeValues.length; j++) {
                    arr.push(alternativeValues[j])
                }
            }
        }
        return (arr)
    }

    const getSearchDecisionAndPayload = (additionalFilterArr) => {

        let searchDecision = ""
        let payload = {}
        let selectedSkillsValue = additionalSkillValues.map((item) => item.trim())
        let selectedPrimarySkillValue = primarySkillValues.map((item) => item.trim())
        let selectedEducationValue = getEducationData(selectedEducation)
        let additionalFilterArrKeysLength = Object.keys(additionalFilterArr).length

        if (selectedKeywords.length > 0 && (selectedSkillsValue.length > 0 || selectedPrimarySkillValue.length > 0 || (expectedSalaryValue !== 0 && expectedSalaryValue !== "") || (currentSalaryValue !== 0 && currentSalaryValue !== '')
            || selectedCurrency || selectedIndustry || selectedEducationValue.length > 0 || selectedUnlistedCompany || selectedCompany || minExperience || maxExperience ||
            noticeperiod || Object.keys(userInformation.locationCountry).length > 0 || Object.keys(userInformation.locationState).length > 0 ||
            Object.keys(userInformation.locationCity).length > 0 || scorePercentage !== 0 || additionalFilterArrKeysLength > 0
        )) {
            payload = {
                operator: booleanFilterOn ? "OR" : "AND",
                keywords: selectedKeywords,
                skills: selectedSkillsValue.length > 0 ? selectedSkillsValue : '',
                primarySkill: selectedPrimarySkillValue.length > 0 ? selectedPrimarySkillValue : '',
                currentSalary: currentSalaryValue !== 0 ? currentSalaryValue : '',
                expectedSalary: expectedSalaryValue !== 0 ? expectedSalaryValue : '',
                Currency: selectedCurrency ? selectedCurrency : '',
                Industry: selectedIndustry ? selectedIndustry.name : '',
                education: selectedEducationValue.length > 0 ? selectedEducationValue : '',
                company: companyNotListed ? selectedUnlistedCompany : selectedCompany ? (selectedCompany.name).trim() : '',
                minYearsOfExperience: minExperience ? minExperience : (maxExperience ? 0 : ''),
                maxYearsOfExperience: maxExperience ? maxExperience : '',
                noticePeriod: noticeperiod ? noticeperiod.value : '',
                country: userInformation.locationCountry ? userInformation.locationCountry.name : '',
                state: userInformation.locationState ? userInformation.locationState.name : '',
                city: userInformation.locationCity ? userInformation.locationCity.name : '',
                OrgId: userRecruitmentpartnerId,
                testScore: scorePercentage ? scorePercentage : null,
                additionalFilterArr: JSON.stringify(additionalFilterArr)

            }
            searchDecision = "combinedSearch"
        }
        else if (selectedKeywords.length > 0) {
            payload = {
                operator: booleanFilterOn ? "OR" : "AND",
                keywords: selectedKeywords,
                OrgId: userRecruitmentpartnerId
            }
            searchDecision = "KeywordSearch"
        }
        else {
            payload = {
                skills: selectedSkillsValue.length > 0 ? selectedSkillsValue : '',
                primarySkill: selectedPrimarySkillValue.length > 0 ? selectedPrimarySkillValue : '',
                currentSalary: currentSalaryValue !== 0 ? currentSalaryValue : '',
                expectedSalary: expectedSalaryValue !== 0 ? expectedSalaryValue : '',
                Currency: selectedCurrency ? selectedCurrency : '',
                Industry: selectedIndustry ? selectedIndustry.name : '',
                education: selectedEducationValue.length > 0 ? selectedEducationValue : '',
                company: companyNotListed ? selectedUnlistedCompany : selectedCompany ? (selectedCompany.name).trim() : '',
                minYearsOfExperience: minExperience ? minExperience : (maxExperience ? 0 : ''),
                maxYearsOfExperience: maxExperience ? maxExperience : '',
                noticePeriod: noticeperiod ? noticeperiod.value : '',
                country: userInformation.locationCountry ? userInformation.locationCountry.name : '',
                state: userInformation.locationState ? userInformation.locationState.name : '',
                city: userInformation.locationCity ? userInformation.locationCity.name : '',
                OrgId: userRecruitmentpartnerId,
                testScore: scorePercentage ? scorePercentage : null,
                additionalFilterArr: JSON.stringify(additionalFilterArr)
            }
            searchDecision = "keyValueSearch"
        }
        let decisionArr = {
            searchDecision: searchDecision,
            payload: payload
        }
        return decisionArr;
    }

    const candidateSearchHandler = async () => {
        setDataResult1([])
        setIsCandidateSearch(true)
        // Clear any active table filters before performing a search
        setTableFilterArray([]);
        setDataState1({
            skip: 0,
            take: 20,
            filter: {
                logic: "and",
                filters: [],
            },
        })
        // bump reset key to remount DataTable and clear internal column filter inputs
        setDataTableResetKey(prev => prev + 1);

        let additionalFilterArr = {}

        let searchDecisionArr = getSearchDecisionAndPayload(additionalFilterArr);
        let searchDecision = searchDecisionArr.searchDecision;
        let searchPayloadData = searchDecisionArr.payload;
        searchPayloadData.sortingField = "created_at";
        searchPayloadData.sortingOrder = "desc";
        setSortingField("created_at");
        setSortingOrder("desc");
        setTypeOfSearch(searchDecision)
        setCandidateSearchPayload(searchPayloadData)
        const take = initialDataState.take;
        const skip = initialDataState.skip;
        const page = Math.floor(skip / take) + 1;
        setTakeNumberOfResult(take);
        setPageNumber(page);

        try {
            await handleCandidateSearchStateChange(searchDecision, searchPayloadData, page, take)
        } catch (error) {
            console.log("error", error)
        }
    }

    const getSearchResult = async (searchDecision, payload, exportExcel) => {
        let res;
        try {
            if (searchDecision === "combinedSearch") {
                res = await candidateCombinedSearch(payload)
            }
            else if (searchDecision === "KeywordSearch") {
                res = await candidateKeySearch(payload)
            }
            else {
                res = await candidateSearch(payload)
            }

            let arr = []
            if (res[0]?.data?.message === "Keyword search should not include numerical values.") {
                NotificationManager.error("Keyword search should not include numerical values", "Error", 10000);
                return arr;
            }
            else {
                if (res.length > 0) {
                    let response = res[0].data
                    if (!exportExcel) {
                        if (res[0]?.totalCount[0]?.total) {
                            setTotalCandidateCount(res[0].totalCount[0].total)
                        }
                        else {
                            setTotalCandidateCount(0)
                        }
                    }
                    for (let i = 0; i < response.length; i++) {
                        let yoe = response[i].yr_of_exp ? parseInt(response[i].yr_of_exp) : 0
                        let fulladdress = " " + (response[i].address ? response[i].address + ", " : '') + (response[i].city ? response[i].city + ", " : '') + (response[i].state ? response[i].state + ", " : '') + (response[i].country ? response[i].country + " " : '')
                        let allSkillString = handleSkillMerge(response[i].skills)
                        let allAdditionalSkillString = response[i].skills.join(", ")
                        if (allSkillString.length > 100) {
                            allSkillString = allSkillString.substring(0, 100)
                        }
                        let degreesValue = response[i].degrees
                        let degreeStr = '';
                        for (let j = 0; j < degreesValue.length; j++) {
                            if (j === degreesValue.length - 1) {
                                degreeStr = degreeStr + degreesValue[j].trim()
                            }
                            else {
                                degreeStr = degreeStr + degreesValue[j].trim() + ', '
                            }
                        }
                        let testnames = ""
                        let testskills = ""
                        let testScores = ""
                        if (response[i]?.testDetails && response[i]?.testDetails.length > 0) {
                            let testDetails = response[i].testDetails;
                            for (let j = 0; j < testDetails.length; j++) {
                                if (j === testDetails.length - 1) {
                                    testnames += testDetails[j].testName
                                    testskills += testDetails[j].testSkillName
                                    testScores += testDetails[j].testScore + "%"
                                }
                                else {
                                    testnames += testDetails[j].testName + ", "
                                    testskills += testDetails[j].testSkillName + ", "
                                    testScores += testDetails[j].testScore + "% , "
                                }
                            }
                        }
                        arr.push(
                            Object.assign(
                                response[i],
                                { allSkill: allSkillString },
                                { allAdditionalSkill: allAdditionalSkillString },
                                { fulladdress: fulladdress },
                                { yearsofexp: yoe },
                                { degreeField: degreeStr },
                                { testnames: testnames },
                                { testskills: testskills },
                                { testScores: testScores }
                            )
                        );
                    }
                    setIsSearching(false)
                    if (scorePercentage !== 0) {
                        setSerachingThroughTestScore(true)
                    } else {
                        setSerachingThroughTestScore(false)
                    }
                    return arr;
                }
                else {
                    setTotalCandidateCount(0)
                    setIsSearching(false)
                    return arr;
                }
            }

        } catch (error) {
            console.log("error", error)
        }
    }

    const keywordTextFieldChange = (e) => {
        setKeywordCurrentValue(e.target.value)
        let arr = [];
        arr.push(e.target.value)
        setKeywordOptions(arr)
    }

    const keywordValuechangeHandler = (e, value) => {
        setSelectedKeywords(value)
        setKeywordOptions([])

    }

    const handleSkillMerge = (skills) => {
        let allSkillData_fetch = skills
        let allSkillString = ''
        for (let j = 0; j < allSkillData_fetch.length; j++) {
            if (j !== allSkillData_fetch.length - 1) {
                allSkillString += allSkillData_fetch[j] + ", "
            }
            else {
                allSkillString += allSkillData_fetch[j]
            }
        }
        return (allSkillString)
    }

    const handleMoreClick = (props) => {
        let skillsData = handleSkillMerge(props?.dataItem?.skills)

        if (openedTab === tab_types.recommended_candidates) {
            let index = dataResult.findIndex((item) => item._id === props.dataItem._id)
            if (index !== -1) {
                let updatedResults = [...dataResult]
                updatedResults[index] = {...updatedResults[index], allSkill: skillsData}
                setDataResult(updatedResults);
            }
        } else {
            let index = dataResult1.findIndex((item) => item._id === props.dataItem._id)
            if (index !== -1) {
                let updatedResults = [...dataResult1]
                updatedResults[index] = {...updatedResults[index], allSkill: skillsData}
                setDataResult1(updatedResults);
            }
        }
    }

    const handlelessClick = (props) => {
        let skillsData = handleSkillMerge(props?.dataItem?.skills)
        let truncatedSkills = skillsData?.substring(0, 100)

        if (openedTab === tab_types.recommended_candidates) {
            let index = dataResult.findIndex((item) => item._id === props.dataItem._id)
            if (index !== -1) {
                let updatedResults = [...dataResult]
                updatedResults[index] = {...updatedResults[index], allSkill: truncatedSkills}
                setDataResult(updatedResults);
            }
        } else {
            let index = dataResult1.findIndex((item) => item._id === props.dataItem._id)
            if (index !== -1) {
                let updatedResults = [...dataResult1]
                updatedResults[index] = {...updatedResults[index], allSkill: truncatedSkills}
                setDataResult1(updatedResults);
            }
        }
    }

    const primarySkillTextFieldHandler = (e) => {
        setCurrentPrimarySkillValue(e.target.value)
        let arr = [];
        arr.push(e.target.value)
        setPrimarySkillOptions(arr)
    }

    const primaryskillchangehandler = (e, value) => {
        setPrimarySkillValues(value)
        setPrimarySkillOptions([])
    }



    const additionalSkillTextFieldHandler = (e) => {
        setCurrentAdditionalSkillValue(e.target.value)
        let arr = [];
        arr.push(e.target.value)
        setAdditionalSkillOptions(arr)
    }

    const additionalSkillChangeHandler = (e, value) => {
        setAdditionalSkillValues(value)
        setAdditionalSkillOptions([])
    }

    const excelExport = async () => {

        setIsExporting(true)

        try {
            let page = 1
            let size = openedTab === tab_types.search_candidates ? totalCandidateCount : totalCandidateCount_RecommendedCandidates;
            let searchPayloadData = candidateSearchPayload;
            let exportArr = [];
            let allCandidateResponse;
            if (isCandidateSearch || dataState1.filter.filters.length > 0) {
                let searchDecision = typeOfSearch;
                searchPayloadData.page = page
                searchPayloadData.size = size;
                searchPayloadData.sortingField = sortingField;
                searchPayloadData.sortingOrder = sortingOrder;
                searchPayloadData.userId = id;
                allCandidateResponse = await getSearchResult(searchDecision, searchPayloadData, true)
            }
            else {
                let payload = {
                    page: page,
                    size: size,
                    sortingField: searchPayloadData.sortingField,
                    sortingOrder: searchPayloadData.sortingOrder,
                }
                allCandidateResponse = await getAllCandidateProfileResponse(recruitmentpartnerId, payload, true, openedTab)

            }

            if (allCandidateResponse.length === 0) {
                setIsExporting(false)
                NotificationManager.error("No candidates found", "Error", 10000);

            } else {
                allCandidateResponse.forEach(element => {
                    let data = {
                        "Candidate Name": element.name,
                        "Email": element.emailID,
                        "Primary Skill": element.primarySkill,
                        "Additional Skills": element.allAdditionalSkill,
                        "Country": element.country,
                        "State": element.state,
                        "City": element.city,
                        "Educational Degree": element.degreeField,
                        "Years of Experience": element.yearsofexp,
                    }
                    if (scorePercentage !== 0) {
                        data["Test Names"] = element.testnames
                        data["Test Skills"] = element.testskills
                        data["Test Scores"] = element.testScores
                    }
                    exportArr.push(data)
                });


                const MAX_ROWS_PER_SHEET = 500;
                // Lazy load XLSX only when needed for export
                const { utils, writeFile } = await import("xlsx");
                const wb = utils.book_new();

                // Calculate the number of sheets needed
                const sheetCount = Math.ceil(exportArr.length / MAX_ROWS_PER_SHEET);

                // Loop to create sheets
                for (let sheetIndex = 0; sheetIndex < sheetCount; sheetIndex++) {
                    // Get a subset of data for each sheet
                    const startRow = sheetIndex * MAX_ROWS_PER_SHEET;
                    const endRow = Math.min((sheetIndex + 1) * MAX_ROWS_PER_SHEET, exportArr.length);
                    const subsetData = exportArr.slice(startRow, endRow);

                    // Convert JSON array to worksheet
                    const ws = utils.json_to_sheet(subsetData);

                    // Append the sheet to the workbook
                    utils.book_append_sheet(wb, ws, `Sheet${sheetIndex + 1}`);
                }

                // Save the workbook to an Excel file
                writeFile(wb, `CandidateData.xlsx`, { bookType: 'xlsx', type: 'file' });
                setIsExporting(false)
            }

        } catch (error) {
            console.log("error", error)
        }
    };

    const goToDashboard = () => {
        history("/dashboard",
            {
                state: {
                    userType: userType,
                    recruitmentPartnerId: userRecruitmentpartnerId,
                    id: id,
                    userRecords: userRecrodData,
                    roleName: userRole
                }
            });
    };


    const handleCandidateSearchStateChange = async (searchDecision, searchPayloadData, page, take) => {
        try {
            setDataResult1([])
            searchPayloadData.page = page
            searchPayloadData.size = take;
            searchPayloadData.userId = id;

            setIsSearching(true)
            let arr = await getSearchResult(searchDecision, searchPayloadData, false)
            setIsSearching(false)
            setDataResult1(arr);
            setAllCandidateSearchResponse(arr)
        } catch (error) {
            console.log("error", error)
        }

    }

    // Helper: handle sorting for Recommended Candidates table
    const handleRecommendedSort = async (sortingState) => {
        if (sortingState && sortingState.length > 0) {
            const sort = sortingState[0];
            const field = sort.id;
            const order = sort.desc ? "desc" : "asc";
            setSortingField(field);
            setSortingOrder(order);

            // Reset to first page when sorting changes
            const page = 1;
            const size = dataState.take;
            setPageNumber(page);
            setTakeNumberOfResult(size);
            setDataState(prev => ({ ...prev, skip: 0, take: size, sort: [{ field, dir: order }] }));

            // Trigger server-side fetch for recommended candidates
            setIsSearching_recommended(true);
            setDataResult([]);
            try {
                await handleCandidateSearchByOrgId(page, size, { sortingField: field, sortingOrder: order });
            } catch (err) {
                console.error('Sorting fetch error (recommended):', err);
            } finally {
                setIsSearching_recommended(false);
            }
        } else {
            setSortingField("created_at");
            setSortingOrder("desc");
        }
    }

    // Helper: handle sorting for Search Candidates table
    const handleSearchSort = async (sortingState) => {
        if (sortingState && sortingState.length > 0) {
            const sort = sortingState[0];
            const field = sort.id;
            const order = sort.desc ? "desc" : "asc";
            setSortingField(field);
            setSortingOrder(order);

            // Reset to first page when sorting changes
            const page = 1;
            const size = dataState1.take || 20;
            setPageNumber(page);
            setTakeNumberOfResult(size);
            setDataState1(prev => ({ ...prev, skip: 0, take: size, sort: [{ field, dir: order }] }));

            // Trigger server-side fetch depending on current mode
            setIsSearching(true);
            setDataResult1([]);
            try {
                // Check if we have active column filters or if it's a candidate search
                if (isCandidateSearch || tableFilterArray.length > 0) {
                    const { searchDecision, searchPayloadData } = createFilteredSearchPayload(page, size, field, order);
                    
                    // Update the stored payload for future pagination
                    if (tableFilterArray.length > 0) {
                        setTypeOfSearch(searchDecision);
                        setCandidateSearchPayload(searchPayloadData);
                    }
                    
                    await handleCandidateSearchStateChange(searchDecision, searchPayloadData, page, size);
                } else {
                    await handleCandidateSearchByOrgId(page, size, { sortingField: field, sortingOrder: order });
                }
            } catch (err) {
                console.error('Sorting fetch error (search):', err);
            } finally {
                setIsSearching(false);
            }
        } else {
            setSortingField("created_at");
            setSortingOrder("desc");
        }
    }

    const tabChange = async (val) => {
        setOpenedTab(val);
        if (tabSwitchCount === 0) {
            setAllCandidateSearchResponse([]);
            setDataResult1([]);
            let payload = {
                page: 1,
                size: 20,
                sortingField: "created_at",
                sortingOrder: 'desc',
            }
            let _recruitmentpartnerId = userRecruitmentpartnerId;
            setRecruimentPartnerId(_recruitmentpartnerId)
            let allCandidateResponse = await getAllCandidateProfileResponse(_recruitmentpartnerId, payload, false, val)
            setAllCandidateSearchResponse(allCandidateResponse)
            setDataResult1(allCandidateResponse);
            setIsSearching(false)
        }
        setTabSwitchCount(tabSwitchCount + 1)

    };

    const getallCandidateData = async () => {
        try {
            let _recruitmentpartnerId = userRecruitmentpartnerId;
            setRecruimentPartnerId(_recruitmentpartnerId)
            let payload = {
                page: pageNumber,
                size: takeNumberOfResult,
                sortingField: "created_at",
                sortingOrder: 'desc',
            }
            let initialTab = requisitionId ? 'Recommended Candidates' : 'Search Candidates';
            setOpenedTab(initialTab)
            let allCandidateResponse = await getAllCandidateProfileResponse(_recruitmentpartnerId, payload, isExporting, initialTab)
            setAllCandidateSearchResponse(allCandidateResponse)
            if (initialTab === 'Search Candidates') {
                setDataResult1(allCandidateResponse);
                setIsSearching(false)
            }
            else {
                setDataResult(allCandidateResponse);
                setIsSearching_recommended(false)
            }
        } catch (error) {
            console.log("error", error)
            setIsSearching(false)
            setIsSearching_recommended(false)
        }
    }

    const fetchIndustries_candidateSearch = async () => {
        try {
            setFilterLoader({ ...filterLoader, industry: true })
            let response_allIndustries = await getAllIndustries()
            setAllIndustries_candidateSearch(response_allIndustries.data.data)
        } catch (error) {
            console.log("error", error)
            NotificationManager.error("Unable to load industry list. Please try again later.", 10000)
        }
        finally {
            setFilterLoader({ ...filterLoader, industry: false })
        }
    }

    const fetchCompanies_candidateSearch = async () => {
        try {
            setFilterLoader({ ...filterLoader, company: true })
            let companiesData = [];
            let response_companies = await getAllCompanies()
            companiesData = response_companies.data.data
            let otherCompanyData = {
                "_id": "",
                "name": "others",
                "created_at": "",
                "updated_at": "",
                "__v": ""
            }
            companiesData.push(otherCompanyData)
            setAllCompanies(companiesData)
        } catch (error) {
            console.log("error", error)
            NotificationManager.error("Unable to load company list. Please try again later.", 10000)
        }
        finally {
            setFilterLoader({ ...filterLoader, company: false })
        }
    }

    const fetchDegrees_candidateSearch = async () => {
        try {
            setFilterLoader({ ...filterLoader, degree: true })
            let response_degrees = await getAllDegrees();
            setDegrees(response_degrees.data.data)
        } catch (error) {
            console.log("error", error)
            NotificationManager.error("Unable to load degree list. Please try again later.", 10000)
        }
        finally {
            setFilterLoader({ ...filterLoader, degree: false })
        }
    }

    useEffect(() => {
        if (!hasInitialAPiRun.current) {
            getCommunityStaticsData();
            getallCandidateData();
            hasInitialAPiRun.current = true;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        const processFilters = async () => {
            if (tableFilterArray.length > 0) {
                const additionalFilterArr = processTableFilters(tableFilterArray);
                const searchDecisionArr = getSearchDecisionAndPayload(additionalFilterArr);

                const searchDecision = searchDecisionArr.searchDecision;
                setTypeOfSearch(searchDecision);
                setCandidateSearchPayload(searchDecisionArr.payload);
                
                const searchPayloadData = {
                    ...searchDecisionArr.payload,
                    page: 1,
                    size: 20,
                    sortingField: sortingField || "created_at",
                    sortingOrder: sortingOrder || "desc",
                    userRecruitmentpartnerId: userRecruitmentpartnerId,
                    userId: id
                };

                const take = 20;
                const page = 1;
                setTakeNumberOfResult(take);
                setPageNumber(page);

                setDataState1({
                    skip: 0,
                    take: take,
                    filter: {
                        logic: "and",
                        filters: [],
                    },
                });

                setIsSearching(true);
                try {
                    let arr = await getSearchResult(searchDecision, searchPayloadData, false);
                    setIsSearching(false);
                    setDataResult1(arr);
                    setAllCandidateSearchResponse(arr);
                } catch (error) {
                    setIsSearching(false);
                    console.error("Filter search error:", error);
                }
            }
        };

        if (tableFilterArray.length > 0) {
            const timeoutId = setTimeout(() => {
                processFilters();
            }, 1000);

            return () => clearTimeout(timeoutId);
        }
    }, [tableFilterArray]); // eslint-disable-line react-hooks/exhaustive-deps



    return (
        <>
            {(userType === "Candidate") ?
                <>
                    <UnauthorizedAccess />
                </>
                : <>
                    <div className='mainContainer_advanceSearch'>
                        <div className='topContainer_advanceSearch'>
                            <div className='mainDiv_advanceSearch'>
                                <div className="communityHeader">
                                    <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                                        <Tooltip title="Go Back to Dashboard" placement="bottom">
                                            <ArrowBackIcon sx={{ fontSize: 20 }} />
                                        </Tooltip>
                                        {/* <span>&nbsp;Go Back to Dashboard</span> */}
                                    </div>
                                    <div className="communityTitle">Candidate Search</div>

                                </div>
                                <div className='infoCardsContainer'>
                                    <div className='infoCard infoCard--blue'>
                                        <div className='infoCardIcon'>
                                            {/* <Groups3Icon sx={{ fontSize: 36 }} /> */}
                                            <Person />

                                        </div>
                                        <div className='infoCardContent'>
                                            <Typography className='infoCardTitle'>Total Community Size</Typography>
                                            <Typography className='infoCardValue'>
                                                {!communityStatsLoader ? <Skeleton variant="text" width={40} /> : communityStats.numberOfCandidates}
                                            </Typography>
                                        </div>
                                    </div>

                                    <div className='infoCard infoCard--green'>
                                        <div className='infoCardIcon'>
                                            {/* <Groups3Icon sx={{ fontSize: 36 }} /> */}
                                            <Calander />

                                        </div>
                                        <div className='infoCardContent'>
                                            <Typography className='infoCardTitle'>Added in last 30 days</Typography>
                                            <Typography className='infoCardValue'>
                                                {!communityStatsLoader ? <Skeleton variant="text" width={40} /> : communityStats.lastthirtydayescandidates}
                                            </Typography>
                                        </div>
                                    </div>

                                    <div className='infoCard infoCard--purple'>
                                        <div className='infoCardIcon'>
                                            {/* <Groups3Icon sx={{ fontSize: 36 }} /> */}
                                            <AddLastWeek />

                                        </div>
                                        <div className='infoCardContent'>
                                            <Typography className='infoCardTitle'>Added in last week</Typography>
                                            <Typography className='infoCardValue'>
                                                {!communityStatsLoader ? <Skeleton variant="text" width={40} /> : communityStats.lastSevenDays}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>





                                <div className="mainContentContainer_advanceSearch">
                                    {openedTab === tab_types.search_candidates && (
                                        <div className="filterContainer_advanceSearch_candidate">
                                            <div className="top-search-bar">
                                                <div className="top-search-text">
                                                    {/* <span className="results-label">Showing results for</span> */}
                                                    <div className="query-label">
                                                        <span className="query-value">Candidate Profile Search</span>
                                                    </div>
                                                </div>

                                                <button
                                                    variant="contained"
                                                    color="primary"
                                                    className="search-btn"
                                                    onClick={candidateSearchHandler}
                                                    disabled={isSearching}
                                                >
                                                    Search
                                                </button>
                                            </div>


                                            <div className="advanced-search-wrapper">
                                                {/* 1. Search Keywords with Boolean Toggle */}
                                                <div className="filter-box">
                                                    <div className='filter-header'>
                                                        <label className="filter-label">Search Keywords</label>
                                                        <div className="keyword-toggle-row">
                                                            <Switch
                                                                checked={booleanFilterOn}
                                                                onChange={() => setBooleanFilterOn(!booleanFilterOn)}
                                                                color="primary"
                                                            />
                                                            <span className="boolean-label">Boolean {booleanFilterOn ? "OR" : "AND"}</span>
                                                        </div>
                                                    </div>
                                                    <Autocomplete
                                                        multiple
                                                        freeSolo
                                                        options={keywordOptions}
                                                        filterSelectedOptions
                                                        value={selectedKeywords}
                                                        onChange={keywordValuechangeHandler}
                                                        className="autocomplete-input"
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                value={keywordCurrentValue}
                                                                onChange={keywordTextFieldChange}
                                                                placeholder="Enter keywords"
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {/* 2. Primary Skill */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Primary Skill</label>
                                                    <Autocomplete
                                                        multiple
                                                        freeSolo
                                                        options={primarySkillOptions}
                                                        filterSelectedOptions
                                                        value={primarySkillValues}
                                                        onChange={primaryskillchangehandler}
                                                        className="autocomplete-input"
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                value={currentPrimarySkillValue}
                                                                onChange={primarySkillTextFieldHandler}
                                                                placeholder="Enter skills"
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {/* 3. Additional Skills */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Additional Skills</label>
                                                    <Autocomplete
                                                        multiple
                                                        freeSolo
                                                        options={additionalSkillOptions}
                                                        filterSelectedOptions
                                                        value={additionalSkillValues}
                                                        onChange={additionalSkillChangeHandler}
                                                        className="autocomplete-input"
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                value={currentAdditionalSkillValue}
                                                                onChange={additionalSkillTextFieldHandler}
                                                                placeholder="Enter skills"
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {/* 4. Years of Experience */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Years of Experience</label>
                                                    <div className="inline-field-row">
                                                        <TextField
                                                            type="number"
                                                            variant="outlined"
                                                            placeholder="Min"
                                                            value={minExperience}
                                                            onChange={minExperienceHandler}
                                                            className="half-width"
                                                        />
                                                        <span>to</span>
                                                        <TextField
                                                            type="number"
                                                            variant="outlined"
                                                            placeholder="Max"
                                                            value={maxExperience}
                                                            onChange={maxExperienceHandler}
                                                            className="half-width"
                                                        />
                                                    </div>
                                                </div>

                                                {/* 5. Location - Country, State, City */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Location</label>
                                                    <Autocomplete
                                                        options={locationList.countryList}
                                                        filterSelectedOptions
                                                        value={userInformation.locationCountry}
                                                        clearOnEscape
                                                        getOptionLabel={(option) => option.name || ""}
                                                        onChange={countryHandler_candidateSearch}
                                                        autoHighlight
                                                        loading={locationList.isCountryFetching}
                                                        onFocus={() => locationList.countryList.length > 0 ? null : fetchLocationInformation("country")}
                                                        componentsProps={{
                                                            popupIndicator: { style: { display: 'none' } },
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                required={true}
                                                                placeholder="Select country"
                                                                slotProps={{
                                                                    input: {
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {locationList.isCountryFetching ? <CircularProgress color="inherit" size={15} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    <Autocomplete
                                                        options={locationList?.stateList}
                                                        value={userInformation.locationState}
                                                        clearOnEscape
                                                        getOptionLabel={(option) => option.name || ""}
                                                        onChange={stateHandler_candidateSearch}
                                                        autoHighlight
                                                        loading={locationList.isStateFetching}
                                                        filterSelectedOptions
                                                        onFocus={() => locationList.stateList.length > 0 ? null : fetchLocationInformation("state")}
                                                        disabled={Object.keys(userInformation.locationCountry).length === 0}
                                                        componentsProps={{
                                                            popupIndicator: { style: { display: 'none' } },
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                required={true}
                                                                placeholder="Select state"
                                                                slotProps={{
                                                                    input: {
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {locationList.isStateFetching ? <CircularProgress color="inherit" size={15} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    <Autocomplete
                                                        options={locationList.cityList}
                                                        
                                                        clearOnEscape
                                                        value={userInformation.locationCity}
                                                        onChange={cityHandler_candidateSearch}
                                                        getOptionLabel={(option) => option.name || ""}
                                                        onFocus={() => locationList.cityList.length > 0 ? null : fetchLocationInformation("city")}
                                                        loading={locationList.isCityFetching}
                                                        autoHighlight
                                                        filterSelectedOptions
                                                        disabled={Object.keys(userInformation.locationState).length === 0}
                                                        componentsProps={{
                                                            popupIndicator: { style: { display: 'none' } },
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                required={true}
                                                                placeholder="Select city"
                                                                slotProps={{
                                                                    input: {
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {locationList.isCityFetching ? <CircularProgress color="inherit" size={15} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {/* 6. Currency + Salary */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Currency & Salary</label>
                                                    <Autocomplete
                                                        options={currencyCodes}
                                                        getOptionLabel={(option) => option || ""}
                                                        value={selectedCurrency}
                                                        onChange={currencyChangeHandler}
                                                        renderInput={(params) => (
                                                            <TextField {...params} variant="outlined" placeholder="Select Currency" />
                                                        )}
                                                    />
                                                    <div className="inline-field-row">
                                                        <OutlinedInput
                                                            placeholder="Current Salary"
                                                            type="number"
                                                            inputProps={{ min: 0 }}
                                                            value={currentSalaryValue}
                                                            onChange={currentSalaryHandler}
                                                            className="half-width"
                                                        />
                                                        <OutlinedInput
                                                            placeholder="Expected Salary"
                                                            type="number"
                                                            inputProps={{ min: 0 }}
                                                            value={expectedSalaryValue}
                                                            onChange={expectedSalaryHandler}
                                                            className="half-width"
                                                        />
                                                    </div>
                                                </div>

                                                {/* 7. Employment - Industry & Company */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Employment</label>
                                                    <Autocomplete
                                                        options={allIndustries_candidateSearch}
                                                        getOptionLabel={(option) => option.name || ""}
                                                        value={selectedIndustry}
                                                        loading={filterLoader.industry}
                                                        onChange={industryChangeHandler}
                                                        onFocus={() => allIndustries_candidateSearch.length > 0 ? null : fetchIndustries_candidateSearch()}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Industry"
                                                                slotProps={{
                                                                    input: {
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {filterLoader.industry ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    <Autocomplete
                                                        options={allCompanies}
                                                        getOptionLabel={(option) => option.name || ""}
                                                        value={selectedCompany}
                                                        loading={filterLoader.company}
                                                        onChange={companyChangeHandler}
                                                        onFocus={() => allCompanies.length > 0 ? null : fetchCompanies_candidateSearch()}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Company"
                                                                slotProps={{
                                                                    input: {
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {filterLoader.company ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {companyNotListed && (
                                                        <TextField
                                                            variant="outlined"
                                                            placeholder="Enter Company Name"
                                                            value={selectedUnlistedCompany}
                                                            onChange={unlistedCompanyValuechangeHandler}
                                                            className="full-width"
                                                        />
                                                    )}
                                                </div>

                                                {/* 8. Education */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Education</label>
                                                    <Autocomplete
                                                        multiple
                                                        filterSelectedOptions
                                                        options={degrees}
                                                        getOptionLabel={(option) => option.degreename || ""}
                                                        value={selectedEducation}
                                                        loading={filterLoader.degree}
                                                        onChange={educationHandler}
                                                        onFocus={() => degrees.length > 0 ? null : fetchDegrees_candidateSearch()}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Education"
                                                                slotProps={{
                                                                    input: {
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {filterLoader.degree ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {/* 9. Notice Period */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Notice Period (Days)</label>
                                                    <Autocomplete
                                                        options={dataForNoticePeriod}
                                                        getOptionLabel={(option) => option.label || ""}
                                                        value={noticeperiod}
                                                        onChange={noticeperiodHandler}
                                                        renderInput={(params) => (
                                                            <TextField {...params} variant="outlined" placeholder="Notice Period" />
                                                        )}
                                                    />
                                                </div>

                                                {/* 10. Percentage Score Slider */}
                                                <div className="filter-box">
                                                    <label className="filter-label">Percentage Score</label>
                                                    <div className="slider-wrapper">
                                                        <Slider
                                                            value={scorePercentage}
                                                            onChange={percentageScoreHandler}
                                                            step={1}
                                                            min={0}
                                                            max={100}
                                                        />
                                                        <span className="slider-value">
                                                            {scorePercentage}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                    <div className="wrapper_advanceSearch">
                                        <div className='tabButtonsWrapper'>
                                            <div
                                                className={`tabButton ${openedTab === tab_types.search_candidates ? 'tabActive' : ''}`}
                                                onClick={() => openedTab === tab_types.search_candidates ? null : tabChange(tab_types.search_candidates)}
                                            >
                                                Search Candidates
                                            </div>
                                            {requisitionId && (
                                                <div
                                                    className={`tabButton ${openedTab === tab_types.recommended_candidates ? 'tabActive' : ''}`}
                                                    onClick={() => openedTab === tab_types.recommended_candidates ? null : tabChange(tab_types.recommended_candidates)}
                                                >
                                                    Recommended Candidates
                                                </div>
                                            )}
                                            <button onClick={excelExport} className="exportExcelBtn">
                                                <ExcelIcon />
                                                 
                                               

                                                <span>Export</span>
                                            </button>
                                            {selectedCandidates.length > 0 && (
                                                <button className="selectedListBtn" onClick={handleDrawerOpen}>
                                                    <span>
                                                        <SelectList />
                                                    </span>
                                                    Selected List ({selectedCandidates.length})
                                                </button>
                                            )}
                                        </div>
                                        <div className='grid-scroll-wrapper'>
                                            {requisitionId && openedTab === tab_types.recommended_candidates ?

                                                <DataTable
                                                    data={dataResult}
                                                    columns={getColumnsForRecommendedCandidates()}
                                                    isLoading={isSearching_recommended}
                                                    totalRecords={totalCandidateCount_RecommendedCandidates}
                                                    currentPage={Math.floor(dataState.skip / dataState.take) + 1}
                                                    pageSize={dataState.take}
                                                    onPageChange={(page, size) => {
                                                        const newDataState = {
                                                            ...dataState,
                                                            skip: (page - 1) * size,
                                                            take: size
                                                        };
                                                        setDataState(newDataState);
                                                        setPageNumber(page);
                                                        setTakeNumberOfResult(size);
                                                        
                                                        // Always use the organizational candidate fetch for recommended candidates
                                                        handleCandidateSearchByOrgId(page, size, {
                                                            sortingField: sortingField,
                                                            sortingOrder: sortingOrder
                                                        });
                                                    }}
                                                    onPageSizeChange={(size) => {
                                                        const newDataState = {
                                                            ...dataState,
                                                            skip: 0,
                                                            take: size
                                                        };
                                                        setDataState(newDataState);
                                                        setPageNumber(1);
                                                        setTakeNumberOfResult(size);
                                                        
                                                        // Always use the organizational candidate fetch for recommended candidates
                                                        handleCandidateSearchByOrgId(1, size, {
                                                            sortingField: sortingField,
                                                            sortingOrder: sortingOrder
                                                        });
                                                    }}
                                                    onFilterChange={handleServerSideFilter}
                                                    onSortingChange={(sortingState) => { handleRecommendedSort(sortingState); }}
                                                    enableFiltering={false}
                                                    enablePagination={true}
                                                    enableSorting={true}
                                                    className='datatable_candidateSearch'
                                                    noDataText="No results found !"
                                                    pageSizeOptions={[10, 20, 50, 100]}
                                                    isServerSide={true}
                                                />

                                                :

                                                <DataTable
                                                    key={dataTableResetKey}
                                                    data={dataResult1}
                                                    columns={getColumnsForSearchCandidates()}
                                                    isLoading={isSearching}
                                                    totalRecords={totalCandidateCount}
                                                    currentPage={Math.floor(dataState1.skip / dataState1.take) + 1}
                                                    pageSize={dataState1.take}
                                                    onPageChange={(page, size) => {
                                                        const newDataState = {
                                                            ...dataState1,
                                                            skip: (page - 1) * size,
                                                            take: size
                                                        };
                                                        setDataState1(newDataState);
                                                        setPageNumber(page);
                                                        setTakeNumberOfResult(size);
                                                        
                                                        // Handle pagination with filters maintained
                                                        if (isCandidateSearch || tableFilterArray.length > 0) {
                                                            const { searchDecision, searchPayloadData } = createFilteredSearchPayload(page, size, sortingField, sortingOrder);
                                                            handleCandidateSearchStateChange(searchDecision, searchPayloadData, page, size);
                                                        } else {
                                                            // Regular organization candidate fetch
                                                            handleCandidateSearchByOrgId(page, size, {
                                                                sortingField: sortingField,
                                                                sortingOrder: sortingOrder
                                                            });
                                                        }
                                                    }}
                                                    onPageSizeChange={(size) => {
                                                        const newDataState = {
                                                            ...dataState1,
                                                            skip: 0,
                                                            take: size
                                                        };
                                                        setDataState1(newDataState);
                                                        setPageNumber(1);
                                                        setTakeNumberOfResult(size);
                                                        
                                                        // Handle page size change with filters maintained
                                                        if (isCandidateSearch || tableFilterArray.length > 0) {
                                                            const { searchDecision, searchPayloadData } = createFilteredSearchPayload(1, size, sortingField, sortingOrder);
                                                            handleCandidateSearchStateChange(searchDecision, searchPayloadData, 1, size);
                                                        } else {
                                                            // Regular organization candidate fetch
                                                            handleCandidateSearchByOrgId(1, size, {
                                                                sortingField: sortingField,
                                                                sortingOrder: sortingOrder
                                                            });
                                                        }
                                                    }}
                                                    onFilterChange={handleServerSideFilter}
                                                    onSortingChange={(sortingState) => { handleSearchSort(sortingState); }}
                                                    enableFiltering={true}
                                                    enablePagination={true}
                                                    enableSorting={true}
                                                    className='datatable_candidateSearch'
                                                    noDataText="No results found !"
                                                    pageSizeOptions={[10, 20, 50, 100]}
                                                    isServerSide={true}
                                                />
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </>
            }
            <Backdrop
                sx={styleSx.backdrop}
                open={isExporting}
            >
                <CircularProgress color="inherit" />
                <Typography sx={styleSx.waitingText}> Please wait ...</Typography>
            </Backdrop>

            {/* Action Dialog */}


            <EditActivity edit={edit} styleSx={styleSx} EditIcon={EditIcon} setEdit={setEdit} setisActivity={setisActivity}
                reqId={reqId}
                email={email}
                props={props}

                moveCandidate={() => { }}
                allRequisitionData={allRequisitionData}
            />


            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleDrawerClose}
                PaperProps={{ sx: { width: 350, display: 'flex', flexDirection: 'column' } }}
            >
                <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #eee' }}>

                    <Typography variant="h6" style={{ flex: 1 }}>Selected Candidates</Typography>
                    <IconButton onClick={handleDrawerClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <List sx={{ flex: 1, overflowY: 'auto', bgcolor: '#f9f9f9' }}>
                    {selectedCandidates.length === 0 ? (
                        <ListItem>
                            <ListItemText primary="No candidates selected." />
                        </ListItem>
                    ) : (
                        selectedCandidates.map((candidate, idx) => (
                            <CandidateCard
                                key={candidate.candidateId || idx}
                                candidate={candidate}
                                onRemove={handleRemoveCandidate}
                            />
                        ))
                    )}
                </List>
                <div style={{ padding: 16, borderTop: '1px solid #eee' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={selectedCandidates.length === 0}
                        onClick={handleBulkSubmit}
                    >
                        {selectedCandidates.length > 1 ? "Bulk Action" : "Action"}
                    </Button>
                </div>
            </Drawer>
            {openBukSubmitModal &&
                <BulkSubmitModal
                    openBukSubmitModal={openBukSubmitModal}
                    setOpenBukSubmitModal={setOpenBukSubmitModal}
                    candidateList={selectedCandidates}
                    setCandidateList={setSelectedCandidates}
                    userType={userType}
                    userId={id}
                    recruitmentpartnerId={userRecruitmentpartnerId}
                    requisitionId={requisitionId}
                    sourcePage="AdvanceSearchTalentCommunity"
                    moveCandidate={() => { }}
                />
            }
        </>
    )
}

export default AdvanceSearchTalentCommunity


